export default __webpack_public_path__ + "static/media/Glassdoor-Logo.abbe4644.svg";